import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useUserRole } from "@/hooks/useUserRole";

/**
 * Blocks pure Assistant users (no other role) from accessing the wrapped route.
 * Assistants can view the calendar (Sessions) but cannot take attendance.
 */
export function AssistantBlockRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { isAdmin, isCoach, isAssociate, isAssistant, loading } = useUserRole(user?.id);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (isAssistant && !isAdmin && !isCoach && !isAssociate) {
    return <Navigate to="/planners" replace />;
  }

  return <>{children}</>;
}
